import { render, staticRenderFns } from "./TablesView.vue?vue&type=template&id=07a35c50&scoped=true&"
import script from "./TablesView.vue?vue&type=script&lang=js&"
export * from "./TablesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a35c50",
  null
  
)

export default component.exports